<template>
  <component :is="issueData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->

    <b-alert variant="danger" :show="issueData === undefined">
      <h4 class="alert-heading">取得入倉資料時出錯</h4>
      <div class="alert-body">
        找不到具有該 ID 的入倉記錄。查看
        <b-link class="alert-link" :to="{ name: 'stock-receive' }">
          入倉列表
        </b-link>
      </div>
    </b-alert>

    <b-tabs v-if="issueData" pills>
      <!-- Tab: Information -->
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">入倉資料</span>
        </template>
        <issue-edit-tab-information
          :issue-data="issueData"
          :product-options="productOptions"
          @refetch-data="refetchData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import issueStoreModule from "../issueStoreModule";
import IssueEditTabInformation from "./IssueEditTabInformation.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    IssueEditTabInformation,
  },
  setup() {
    const issueData = ref(null);

    const USER_APP_STORE_MODULE_NAME = "app-issue";

    const itemFormBlankItem = {
      product_id: null,
      description: "",
      unit_price: 0,
      quantity: 1,
    };

    const issue = {
      id: 0,
      supplier_id: null,
      issue_date: null,
      remark: "",
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
    };

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, issueStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    onMounted(() => {
      refetchOptions();
    });

    const refetchData = () => {
      if (router.currentRoute.name == "stock-issue-create") {
        issueData.value = issue;
      } else {
        store
          .dispatch("app-issue/fetchIssue", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            issueData.value = response.data.issue;
            issueData.value.is_active =
              issueData.value.is_active == 1 ? true : false;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              issueData.value = undefined;
            }
          });
      }
    };

    refetchData();

    const productOptions = ref([]);
    const refetchOptions = () => {
      store
        .dispatch("app/fetchOptionList", { product: true })
        .then((response) => {
          productOptions.value = response.data.products;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    return {
      issueData,
      refetchData,
      productOptions,
    };
  },
};
</script>

<style></style>
